import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { map, catchError, timeout } from 'rxjs/operators';
import { RequestUser, BeerProfileRequest, SearchRequest, RealUser, BrewerySearchRequest, AddBeerRequest, AddBreweryRequest, SearchVenueRequest, SimilarBeerRequest } from "../../models/models";
import { RefdataProvider } from '../../providers/refdata/refdata'

/*
  Generated class for the BeerServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable({
    providedIn: 'root'
})
export class BeerServiceProvider {

  private baseUrl = '';
  private headers = new HttpHeaders({ "x-api-key": "Key1SV0ce45i4Dhrob6VP74IWR45IqRb2wVur7rx" });
  private options = { headers: this.headers };

  constructor(public http: HttpClient, private refdata: RefdataProvider) {
    this.baseUrl = this.refdata.getEnvVar('apiBaseUrl');
  }

  httpPost(url: string, payLoad: any, readableName: string) {
      return this.http.post(url, payLoad, this.options).pipe(
        timeout(30000),
//        map((res: Response) => res.json()),
        catchError((error: any) => {
            if (error && error.error && typeof error.error === 'object' && error.error.message) {
                return throwError(() => new Error(`Server error: ${error.error.message}`));
            } 
            return throwError(() => new Error("Server error: Could not retrieve " + readableName));
        })
      );
  
    }
  getTopBeers(user: RequestUser) {
    let endpoint = "/top";

    //debugger;

    let item1 = { "longitude": "0" };
    let item2 = { "user_id": "6beec78c-8f0b-49dc-9cc3-ad49dda13d92" };
    let myitems = [item1, item2];

    //myitems["bla"] = "tralala";
    //myitems["bli"] = "blibla";
    //myitems["latitude"] = "0";

    let dummyUser: RealUser = new RealUser(1.23, 1.23, myitems);

    let realUser = {};
    realUser["latitude"] = 1.23;
    realUser["longitude"] = 1.23;
    //realUser["longitude"] = "0";
    //realUser["user_id"] = "6beec78c-8f0b-49dc-9cc3-ad49dda13d92";

    //let allitems = dummyUser.items.length;

    let arr = [
      { key: 'longitude', val: '3.45' },
      { key: 'user_id', val: '6beec78c-8f0b-49dc-9cc3-ad49dda13d92' }
    ];

    let result = arr.reduce(function (map, obj) {
      map[obj.key] = obj.val;
      return map;
    }, {});

    result["latitude"] = 1.23;

    return this.http.post(this.baseUrl + endpoint, realUser, this.options).pipe(
      timeout(30000),
//      map((res: Response) => res.json()),
      map(res => {
        map((beer: any) => {
          //console.log(JSON.stringify(beer));
          if (beer.beer.logo !== undefined && beer.beer.logo != null) {
            console.log("TOP BEERS - using beer logo");
            beer.beer.logoUrl = this.refdata.getEnvVar('beerLogoBaseUrl') + beer.beer.logo;
          }
          else if (beer.beer.brewery.logo !== undefined && beer.beer.brewery.logo != null) {
            console.log("TOP BEERS - using brewery logo");
            beer.beer.logoUrl = this.refdata.getEnvVar('breweryLogoBaseUrl') + beer.beer.brewery.logo;
          }
          else {
            console.log("TOP BEERS - no logo available...");
            beer.beer.logoUrl = "../assets/svg/icon_beerglass.svg";
          }
        })
        return res;
      }),
      catchError((error: any) => {
            if (error && error.error && typeof error.error === 'object' && error.error.message) {
                return throwError(() => new Error(`Server error: ${error.error.message}`));
            } 
            return throwError(() => new Error("Server error: Could not retrieve " + endpoint));
        }));
  }

  getStats(user: RequestUser) {
    let endpoint = "/stats";
    return this.httpPost(this.baseUrl + endpoint, user, endpoint);
  }

  getBeerProfile(beerProfileRequest: BeerProfileRequest) {
    let endpoint = "/profile";
    return this.httpPost(this.baseUrl + endpoint, beerProfileRequest, endpoint);
  }

  getSimilarBeers(similarBeerRequest: SimilarBeerRequest) {
    let endpoint = "/similarbeers";
    return this.httpPost(this.baseUrl + endpoint, similarBeerRequest, endpoint);
  }

  getSearchCount(searchRequest: SearchRequest) {
    let endpoint = "/searchcount";
    return this.httpPost(this.baseUrl + endpoint, searchRequest, endpoint);
  }

  search(searchRequest: SearchRequest) {
    let endpoint = "/search";
    return this.http.post(this.baseUrl + endpoint, searchRequest, this.options).pipe(
      timeout(30000),
//      map((res: Response) => res.json()),
      map(res => {
        map((beer: any) => {
          if (beer.logo !== undefined && beer.logo != null) {
            beer.logoUrl = this.refdata.getEnvVar('beerLogoBaseUrl') + beer.logo;
            console.log("LOGO - using beer logo: " + beer.logoUrl);
          } else {
            if (beer.brewery.logo !== undefined && beer.brewery.logo != null) {
              beer.logoUrl = this.refdata.getEnvVar('breweryLogoBaseUrl') + beer.brewery.logo;
              console.log("LOGO - using brewery logo: " + beer.logoUrl);
            }
            else {
              beer.logoUrl = "../assets/svg/icon_beerglass.svg";
              console.log("LOGO - using default logo! nor brewery nor beer logo found!");
            }

          }
        })
        return res;
      }),
      catchError((error: any) => {
            if (error && error.error && typeof error.error === 'object' && error.error.message) {
                return throwError(() => new Error(`Server error: ${error.error.message}`));
            } 
            return throwError(() => new Error("Server error: Could not retrieve " + endpoint));
        }));
  }

  brewerySearch(brewerySearchRequest: BrewerySearchRequest) {
    let endpoint = "/searchbrewery";
    return this.httpPost(this.baseUrl + endpoint, brewerySearchRequest, endpoint);
  }

  addBeer(addBeerRequest: AddBeerRequest) {
    let endpoint = "/addbeer";
    return this.httpPost(this.baseUrl + endpoint, addBeerRequest, endpoint);
  }

  addBrewery(addBreweryRequest: AddBreweryRequest) {
    let endpoint = "/addbrewery";
    return this.httpPost(this.baseUrl + endpoint, addBreweryRequest, endpoint);
  }

  requestNearbyBeerhiveVenues(searchVenueRequest: SearchVenueRequest) {
    let endpoint = "/searchvenue";
    return this.httpPost(this.baseUrl + endpoint, searchVenueRequest, endpoint);
  }

  // TODO API implementation
  requestUserVenues(requestUser: RequestUser) {
    console.log("beer-service - requestUserVenues NOT IMPLEMENTED YET using default venues");
    return [{
       id: 1,
       name: "Beerhive tasting"
     },
     {
       id: 2,
       name: "De Fazanten"
     }];
  }
}
